import { useMutation, useQueryClient } from "@tanstack/react-query";

import { alertSchemaService } from "../../../services/alertSchemasService";

export const useDeleteAlertSchema = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({ alertSchemaId }: { alertSchemaId: string }) => {
      const deleted = await alertSchemaService.delete(alertSchemaId);
      return { deleted, alertSchemaId };
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["alert-providers"] });
    },
  });
};
